<div class="dialog-wrapper">
  <h2 mat-dialog-title>
    {{ "brand.campaign.submitConfirmTitle" | translate }}
  </h2>
  <mat-dialog-content>
    <div class="dialog-title">
      {{ "brand.campaign.submitConfirmDescription" | translate }}
    </div>
    <div class="pre-check-wrap">
      <div class="pre-check-wrap-col">
        <div class="row">
          <div class="title">
            <mat-icon class="success-icon">check_circle</mat-icon>
            {{ "brand.partnerImportList.inviteDialogCampaignName" | translate }}
          </div>
          <div class="subtitle">{{ campaign.name }}</div>
        </div>
        <div class="row">
          <div class="title">
            @if (inviteCodeCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.inviteDialogInviteCode" | translate }}
          </div>
          <div class="subtitle subtitle--break-anywhere">
            {{ campaign.invitationCode }}
          </div>
          @if (!inviteCodeCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/settings'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        <div class="row">
          <div class="title">
            @if (featImgCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{
              "brand.partnerImportList.inviteDialogFeaturedImage" | translate
            }}
          </div>
          @if (!featImgCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/settings'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        <div class="row">
          <div class="title">
            @if (brandLogoCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.inviteDialogBrandLogo" | translate }}
          </div>
          @if (!brandLogoCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/invite-page'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        @if (adsActiveCheck) {
          <div class="row">
            <div class="title">
              <mat-icon class="success-icon">check_circle</mat-icon>
              <span>
                {{ "brand.partnerImportList.promoAdsEnabled" | translate }}
              </span>
            </div>
            <div class="subtitle">
              {{ campaign.currencySymbol }}{{ campaign.budget }}
              {{ "shared.perPartner" | translate }}
            </div>
          </div>
          @if (googleAdsEnabled) {
            <div class="row">
              <div class="title">
                @if (googleAdsTargetingCheck) {
                  <mat-icon class="success-icon">check_circle</mat-icon>
                } @else {
                  <mat-icon class="error-icon">error</mat-icon>
                }
                {{ "brand.partnerImportList.gAdsTargeting" | translate }}
              </div>
              @if (!googleAdsTargetingCheck) {
                <a
                  class="solve-issue"
                  [routerLink]="[
                    '/brand/' +
                      campaign.brand.id +
                      '/campaigns/' +
                      campaign.id +
                      '/promoted-ads'
                  ]"
                  [queryParams]="{ page: 'marketing-channels' }"
                  [mat-dialog-close]="false"
                >
                  {{ "brand.campaign.solveIssue" | translate }}
                </a>
              }
            </div>
          }
        }
      </div>
      <div class="pre-check-wrap-col">
        <div class="row">
          <div class="title">
            @if (inviteLinkCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.inviteDialogInviteLink" | translate }}
          </div>
          <div class="subtitle subtitle--break-anywhere">
            {{ campaign.getInvitationLink() }}
          </div>
          @if (!inviteLinkCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/settings'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        <div class="row">
          <div class="title">
            @if (timeFrameCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.inviteDialogTimeframe" | translate }}
          </div>
          <div class="subtitle">
            {{ campaign.startDate | date: "YYYY-MM-dd" }} -
            {{ campaign.endDate | date: "YYYY-MM-dd" }}
          </div>
          @if (!timeFrameCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/settings'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        <div class="row">
          <div class="title">
            @if (inviteImgCheck) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.inviteDialogInviteImg" | translate }}
          </div>
          @if (!inviteImgCheck) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/information/invite-page'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        <div class="row">
          <div class="title">
            @if (contentScheduled && contentWithinPeriod) {
              <mat-icon class="success-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="error-icon">error</mat-icon>
            }
            {{ "brand.partnerImportList.contentScheduled" | translate }}
          </div>
          <div class="subtitle">
            @if (!contentScheduled) {
              {{
                "brand.partnerImportList.contentScheduledDescriptionNoPosts"
                  | translate
              }}
            } @else if (!contentWithinPeriod) {
              {{
                "brand.partnerImportList.contentScheduledDescriptionOutsideRange"
                  | translate
              }}
            } @else {
              {{
                "brand.partnerImportList.contentScheduledDescription"
                  | translate
              }}
            }
          </div>
          @if (!contentScheduled || !contentWithinPeriod) {
            <a
              class="solve-issue"
              [routerLink]="[
                '/brand/' +
                  campaign.brand.id +
                  '/campaigns/' +
                  campaign.id +
                  '/content-calendar'
              ]"
              [mat-dialog-close]="false"
            >
              {{ "brand.campaign.solveIssue" | translate }}
            </a>
          }
        </div>
        @if (adsActiveCheck) {
          <div class="row">
            <div class="title">
              @if (maxAdsScheduledCheck) {
                <mat-icon class="success-icon">check_circle</mat-icon>
              } @else {
                <mat-icon class="error-icon">error</mat-icon>
              }
              {{
                "brand.partnerImportList.adsScheduledDescription" | translate
              }}
            </div>

            @if (!maxAdsScheduledCheck) {
              <a
                class="solve-issue"
                [routerLink]="[
                  '/brand/' +
                    campaign.brand.id +
                    '/campaigns/' +
                    campaign.id +
                    '/content-calendar'
                ]"
                [mat-dialog-close]="false"
              >
                {{ "brand.campaign.solveIssue" | translate }}
              </a>
            }
          </div>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn btn--transparent" [mat-dialog-close]="false">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      [disabled]="!campaignInformationCompleted"
      class="btn btn--primary"
      (click)="dialogRef.close(true)"
    >
      {{ "shared.submit" | translate }}
    </button>
  </mat-dialog-actions>
</div>
